import {mainQuery} from '@github-ui/react-core/future/main-query'

import {commitsAppBuilder} from '../config/app-builder'
import type {CommitsPayload} from '../types/commits-types'

export const commitsRefPathRoute = commitsAppBuilder.createQueryRouteConfig('commitsRefPathRoute', {
  path: '/:owner/:repo/commits/:ref/:path/*',
  queries: [
    mainQuery<CommitsPayload>({
      queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: searchParams.toString()}),
    }),
  ],
})
